type FollowEventListener = () => void;

class FollowEvents {
  private listeners: Set<FollowEventListener> = new Set();

  onFollowChange(listener: FollowEventListener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  emitFollowChange(): void {
    this.listeners.forEach(listener => listener());
  }
}

export const followEvents = new FollowEvents();

